module.exports = window['powerbi-client'];


/*****************
 ** WEBPACK FOOTER
 ** external "window['powerbi-client']"
 ** module id = 18
 ** module chunks = 0
 **/